import { getAllRuleSets, processTabsData, updateCondition, getNewTab, defaultRule } from '@/services/configurations'
import { thresholdKeys, vitalPlaceholders, getDefaultVitalInfo } from '@/constants/thresholds'

const state = {
  currentRuleSetIndex: 0,
  currentRuleIndex: 0,
  newRuleSetInitiated: false,
  rulesets: [],
  currentModelDataIndex: 0,
  currentModelIndex: 0,
  newModelInitiated: false,
  modelData: [
    {
      name: 'fire-alarm',
      state: '',
      updated_at: '2021-04-30T09:24:21.946Z',
      id: '5eb50672260cd325434c832d'
    },
    {
      name: 'model1',
      state: 'active',
      updated_at: '2021-04-29T12:07:32.632Z',
      id: '603525269b03ab45b2e379e0'
    },
    {
      name: 'model2',
      state: '',
      updated_at: '2021-03-02T17:46:39.295Z',
      id: '603c92a16a3a9a1d0a6afe0b'
    },
    {
      name: 'model3',
      state: '',
      updated_at: '2021-04-21T09:45:33.642Z',
      id: '607ff43c7b3b3aba76ea6ba6'
    },
    {
      name: 'model4',
      state: '',
      updated_at: '2021-04-21T09:48:45.375Z',
      id: '607ff4fb7b3b3a17b7ea6ba8'
    }
  ]
}

const modules = {}

const getters = {
  // for rulesets
  currentRuleSetIndex: state => state.currentRuleSetIndex,
  newRuleSetInitiated: state => state.newRuleSetInitiated,
  currentRuleIndex: state => state.currentRuleIndex,
  rulesets: state => state.rulesets,
  currentRuleSet: state => state.rulesets[state.currentRuleSetIndex],
  currentRule: state => state.rulesets[state.currentRuleSetIndex]?.rules[state.currentRuleIndex],
  condition: state => state.rulesets[state.currentRuleSetIndex]?.rules[state.currentRuleIndex]?.condition,

  // for models
  currentModelDataIndex: state => state.currentModelDataIndex,
  newModelInitiated: state => state.newModelInitiated,
  currentModelIndex: state => state.currentModelIndex,
  modelData: state => state.modelData,
  currentModel: state => state.modelData[state.currentModelDataIndex]
  // currentRule: state => state.rulesets[state.currentModelDataIndex]?.rules[state.currentModelIndex]
  // condition: state => state.rulesets[state.currentModelDataIndex]?.rules[state.currentModelIndex]?.condition
}

const mutations = {
  setSingleProperty: (state, [prop, value]) => {
    state[prop] = value
  },
  setSinglePropertyCurrentRuleSet: (state, [prop, value]) => {
    state.rulesets[state.currentRuleSetIndex][prop] = value
  },
  setSinglePropertyCurrentModel: (state, [prop, value]) => {
    state.modelData[state.currentModelIndex][prop] = value
  },
  setSinglePropertyCurrentRule: (state, [prop, value]) => {
    state.rulesets[state.currentRuleSetIndex].rules[state.currentRuleIndex][prop] = value
  },
  newRuleSet: (state) => {
    if (state.newRuleSetInitiated) {
      state.rulesets.pop()
    }
    state.rulesets.push(getNewTab())
    state.newRuleSetInitiated = true
    state.currentRuleSetIndex = state.rulesets.length - 1
  },
  newModel: (state) => {
    if (state.newModelInitiated) {
      state.modelData.pop()
    }
    state.modelData.push(getNewTab())
    state.newModelInitiated = true
    state.currentModelDataIndex = state.modelData.length - 1
  },
  newRule: (state, ageRanges) => {
    state.rulesets[state.currentRuleSetIndex].rules.push(defaultRule(ageRanges))
  },
  removeRule: (state, index) => {
    state.rulesets[state.currentRuleSetIndex].removedRules = state.rulesets[state.currentRuleSetIndex].removedRules || []
    state.rulesets[state.currentRuleSetIndex].removedRules.push(state.rulesets[state.currentRuleSetIndex].rules.splice(index, 1)[0])
    state.currentRuleIndex = state.currentRuleIndex ? state.currentRuleIndex - 1 : 0
  },
  setCondition: (state, [condition]) => {
    if (state.rulesets[state.currentRuleSetIndex].rules[state.currentRuleIndex]) {
      state.rulesets[state.currentRuleSetIndex].rules[state.currentRuleIndex].condition = condition
      for (const key of thresholdKeys) {
        state.rulesets[state.currentRuleSetIndex].rules[state.currentRuleIndex][key].is_included = condition?.includes(vitalPlaceholders[key].key)
      }
    }
  },
  resetRule: (state, prop) => {
    if (state.rulesets[state.currentRuleSetIndex].rules[state.currentRuleIndex][prop].is_included) {
      let condition = JSON.parse(state.rulesets[state.currentRuleSetIndex].rules[state.currentRuleIndex].condition)
      condition = updateCondition(condition, condition.indexOf(vitalPlaceholders[prop].key))
      state.rulesets[state.currentRuleSetIndex].rules[state.currentRuleIndex].condition = JSON.stringify(condition)
    }
    state.rulesets[state.currentRuleSetIndex].rules[state.currentRuleIndex][prop] = getDefaultVitalInfo()
  }
}

const actions = {
  setSingleProperty({ commit }, [prop, value]) {
    commit('setSingleProperty', [prop, value])
  },
  setCurrentRuleSetIndex({ commit }, index) {
    commit('setSingleProperty', ['currentRuleSetIndex', index])
    commit('setSingleProperty', ['currentRuleIndex', 0])
  },
  setCurrentModelDataIndex({ commit }, index) {
    commit('setSingleProperty', ['currentModelDataIndex', index])
    commit('setSingleProperty', ['currentModelIndex', 0])
  },
  setCurrentRuleIndex({ commit }, index) {
    commit('setSingleProperty', ['currentRuleIndex', index])
  },
  setCurrentRuleName({ commit }, value) {
    commit('setSinglePropertyCurrentRuleSet', ['name', value])
  },
  setCurrentModelName({ commit }, value) {
    commit('setSinglePropertyCurrentModel', ['name', value])
  },
  setSinglePropertyCurrentRule({ commit }, { prop, value }) {
    commit('setSinglePropertyCurrentRule', [prop, value])
  },
  newRuleSet({ commit }) {
    commit('newRuleSet')
  },
  newModel({ commit }) {
    commit('newModel')
  },
  newRule({ commit }, ageRanges) {
    commit('newRule', ageRanges)
  },
  removeRule({ commit }, index) {
    commit('removeRule', index)
  },
  setRulesSets({ commit }, rulesets) {
    commit('setSingleProperty', ['rulesets', rulesets])
  },
  setCondition({ commit }, condition) {
    commit('setCondition', [condition])
  },
  resetRule({ commit }, prop) {
    commit('resetRule', prop)
  },
  async fetchAndUpdateRulesSets({ commit }) {
    const rules = await getAllRuleSets()
    const rulesets = processTabsData(rules)
    commit('setSingleProperty', ['rulesets', rulesets])
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
  modules
}
